import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CardMedia, Grid2 } from '@mui/material';
import ReviewRatingCom from '../../../features/student/ReviewRatingCom';
import { useCourseApartmentList, useCourseDetail, useNewCourseDetail, usePriceCourseDetail } from '../../../assets/api/UseStudentGetApi';
import { SkeletonCom, TextSkeleton } from '../../utils/SkeletonCom';
import useCourseIdStore from '../../../store/useCourseIdStore';
import { BulletList } from '../../utils/BulletList';
import { GridChildren } from '../../utils/LingtBlueContainer';
import { Frontend_URL, Grid_Gap, ImagePath, ImageRelativePath } from '../../constants';
import api from '../../../assets/api/useStudentPostApi';
import { useMutation } from '@tanstack/react-query';
import useAuthStore from '../../../store/useAuthStore';
import PurchasedCourseCard, { PriceSection } from './PurchasedCourseCard';
import { useToaster } from '../../utils/ToasterProvider';
import { Field, Form, Formik } from 'formik'
import { AutoCompleteField } from '../formfields/AutoCompleteField';


const ViewCourseDetail = ({ ispurchase = false, slug }) => {
    const { token, user } = useAuthStore()
    const { courseId } = useCourseIdStore();
    const [apartmentName, setApartmentName] = React.useState("");
    const { data: coursesDetail, isLoading } = useCourseDetail(courseId);
    const { data: newCourse, isLoading: isNewCourseLaoding } = useNewCourseDetail({ slug: slug });
    const isType3 = [3, 4, 5].includes(newCourse?.data?.type);
    const { data: coursesApartmentList, isLoading: isLoadingApartmentList } = useCourseApartmentList({ "course_id": courseId });
    const apartmentOptions = coursesApartmentList?.data?.map((apartment, index) => ({
        id: index + 1,
        label: apartment?.apartment_name,
        value: apartment?.apartment_name,
    })) || []
    const { showToaster } = useToaster();
    const { data: coursePriceDetail, isLoading: isPriceDetailIsLoading } = usePriceCourseDetail({
        apartmentName: apartmentName,
        title: coursesDetail?.data?.title
    });
    const createOrderMutation = useMutation({
        mutationFn: (formData) => api.post("collab-course-create-order", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });
    const handlePayment = () => {
        if (!apartmentName) {
            showToaster(`Please select apartment`, '', 'warning')
            return;
        }
        const obj = {
            "event_id": courseId,
            "price": coursePriceDetail?.data?.course_fees,
            "quantity": 1,
            "apartments_id": coursePriceDetail?.data?.apartments_id,
            "order_details": {},
            "details": {
                "firstname": user?.firstname,
                "lastname": user?.lastname,
                "email": user.email
            }
        }

        createOrderMutation.mutate(obj, {
            onSuccess: (order) => {
                if (!order?.data?.payment_order_id) {
                    showToaster('Failed to get order ID from server', '', 'warning')
                    return;
                };
                const options = {
                    key: order?.data?.key,
                    amount: order?.data?.amount,
                    currency: "INR",
                    name: "Myskill.club",
                    description: "Payment for courses",
                    order_id: order?.data?.payment_order_id,
                    handler: async (response) => {
                        const paymentData = {
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature,
                            event_id: courseId,
                            price: coursePriceDetail?.data?.course_fees,
                            quantity: 1,
                            apartments_id: coursePriceDetail?.data?.apartments_id,
                            details: {
                                firstname: user?.firstname,
                                lastname: user?.lastname,
                                email: user.email,
                                course_name: coursesDetail?.data?.title,
                                start_date: coursePriceDetail?.data?.start_date,
                                end_date: coursePriceDetail?.data?.end_date,
                                amount_incl_tax: coursePriceDetail?.data?.course_fees,
                                start_time: coursePriceDetail?.data?.start_time,
                                end_time: coursePriceDetail?.data?.end_time,
                                apartname_name: apartmentName,
                            }
                        };
                        try {
                            const verifyResponse = await api.post("collab-course-payment-callback", paymentData, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            });
                            if (verifyResponse?.data?.message) {
                                showToaster(verifyResponse?.data?.message, '', 'success')
                            } else {
                                showToaster(verifyResponse?.data?.error, '', 'error')
                            }
                        } catch (error) {
                            console.error("Verification Error:", error);
                            showToaster(`Error: ${error.response?.data?.message || "Verification failed"}`, '', 'error')
                        }
                    },
                    theme: { color: "#4169E1" }
                };
                const rzp = new window.Razorpay(options);
                rzp.open();

            },
            onError: (error) => {
                console.error("Error:", error.response);
                showToaster(`Error: ${error.response?.data?.message || "Payment initiation failed"}`, '', 'error')

            },
        });
    };
    return (
        <Box>

            <Grid2 container spacing={"35px"} >
                <Grid2 children size={{ xs: 12, lg: 5 }}>
                    <CardMedia
                        sx={{
                            width: "100%",
                            borderRadius: "15px",
                            height: { xs: "300px", lg: "100%" }
                        }}
                        image={`${ImagePath}${ImageRelativePath}${coursesDetail?.data?.cover_image}`}

                    />
                </Grid2>
                <Grid2 children size={{ xs: 12, lg: 7 }}
                    sx={{
                        maxHeight: { xs: "auto", lg: "60vh" },
                        overflowY: { xs: "auto", lg: "scroll" },
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                    }}
                >
                    {isLoading && (<>
                        <TextSkeleton line={1} width={100} />
                        <TextSkeleton line={1} width={300} />
                        <TextSkeleton line={1} width={300} />
                        <TextSkeleton line={1} width={300} />
                        <TextSkeleton line={6} width={"100%"} />

                    </>)}
                    {!isLoading && (
                        <>
                            <Typography variant='h2'>{coursesDetail?.data?.title}{coursePriceDetail ? `-${coursePriceDetail?.data?.apartment_name}` : ""}</Typography>

                            {
                                !isType3 && <>
                                    {
                                        isPriceDetailIsLoading && <TextSkeleton line={1} width={300} />
                                    }
                                    {
                                        (!isPriceDetailIsLoading && coursePriceDetail && !ispurchase) && <PriceSection
                                            price={coursePriceDetail?.data?.course_fees}
                                            start_date={coursePriceDetail?.data?.start_date}
                                            end_date={coursePriceDetail?.data?.end_date}
                                            apartment={coursePriceDetail?.data?.apartment_name}
                                            start_time={coursePriceDetail?.data?.start_time}
                                            end_time={coursePriceDetail?.data?.end_time} />
                                    }
                                    {
                                        !ispurchase && <Formik initialValues={{ apartment_name: "" }}>
                                            {() => (
                                                <Form>
                                                    <Grid2 container sx={{ display: "flex", alignItems: "flex-end" }} spacing={Grid_Gap}>
                                                        <Grid2 children size={6}>
                                                            <Field
                                                                name="apartment_name"
                                                                component={AutoCompleteField}
                                                                placeholder="Select Apartment"
                                                                options={apartmentOptions}
                                                                onValueChange={(value) => {
                                                                    setApartmentName(value?.value)
                                                                }}
                                                                noOptionsText={"Currently Unavailable"}
                                                                onClear={() => {
                                                                    setApartmentName("");
                                                                }}
                                                                isLoading={isLoadingApartmentList}
                                                            />
                                                        </Grid2>
                                                        <Grid2 children size={6}>
                                                            <Button variant='contained' onClick={handlePayment}>Purchase Course</Button>
                                                        </Grid2>
                                                    </Grid2>
                                                </Form>
                                            )}
                                        </Formik>

                                    }
                                </>
                            }
                            {
                                !ispurchase && isType3 && <Grid2 container>
                                    <Grid2 children size={6}>
                                        <Button variant='contained' onClick={() => { window.location.href = `${Frontend_URL}CoursesDetail/${slug}` }}>Purchase Course</Button>
                                    </Grid2>
                                </Grid2>
                            }


                            <Typography variant='h6' color='secondary.light' my={2}>
                                {coursesDetail?.data?.short_description}
                            </Typography>
                            {coursesDetail?.data?.description?.Objective && (
                                <Box my={2}>
                                    <Typography variant="h5" >
                                        Objective
                                    </Typography>
                                    <Typography variant="h6" color='secondary.light' mt={2}>
                                        {coursesDetail?.data?.description?.Objective}
                                    </Typography>
                                </Box>
                            )}

                            {coursesDetail?.data?.description?.Outcomes && (
                                <Box my={2}>
                                    <BulletList title={"Outcome"} items={coursesDetail?.data?.description?.Outcomes} />
                                </Box>
                            )}

                            {coursesDetail?.data?.description?.description && (
                                <Box my={2}>
                                    <Typography variant="h5" >
                                        Description
                                    </Typography>
                                    <Typography variant="h6" color='secondary.light' mt={2}>
                                        {coursesDetail?.data?.description?.description}
                                    </Typography>
                                </Box>)
                            }

                            {coursesDetail?.data?.description?.Conclusion && (
                                <Box my={2}>
                                    <Typography variant="h5" >
                                        Conclusion
                                    </Typography>
                                    <Typography variant="h6" color='secondary.light' mt={2}>
                                        {coursesDetail?.data?.description?.Conclusion}
                                    </Typography>
                                </Box>
                            )}
                        </>)}


                </Grid2>
                {!ispurchase && (
                    <Grid2 children size={12}>
                        <Typography variant="h4" fontWeight={500}>
                            Review And Rating
                        </Typography>
                        {Array.from({ length: 3 }).map((_, index) => (
                            <ReviewRatingCom key={index} />
                        ))}

                    </Grid2>
                )}



            </Grid2>

            {
                !ispurchase && (
                    <>
                        <Typography variant="h4" fontWeight={500}>
                            Related Courses
                        </Typography>

                        <Grid2 container spacing={Grid_Gap} my={"30px"} sx={{ display: "flex", justifyContent: "space-between" }}>
                            {!isLoading && (
                                coursesDetail?.related_courses.map((item, index) => (
                                    <GridChildren index={index} key={index}>
                                        <PurchasedCourseCard item={item} isopen={false} />
                                    </GridChildren>
                                )))
                            }
                            {isLoading && (
                                [...Array(4)].map((_, index) => (
                                    <GridChildren index={index} key={index}>
                                        <SkeletonCom />
                                    </GridChildren>
                                ))
                            )
                            }
                        </Grid2>
                    </>
                )
            }


        </Box>
    )
}

export default ViewCourseDetail